/**
 * Crest files from `npm run download-logos` live under `/public/club-logos/{code}/{slug}.png`.
 * Slug rules must stay aligned with `scripts/download-club-logos.mjs` at repo root
 * (slugForClubLogo). Run via `./download-club-logos.sh` or `npm run download-logos` from website/.
 */
export function slugForClubLogo(label) {
  if (!label) return '';
  return label
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

/** @param {string} leagueCode e.g. PL, PD */
export function clubLogoUrl(leagueCode, teamLabel) {
  const slug = slugForClubLogo(teamLabel);
  if (!slug || !leagueCode) return '';
  return `/club-logos/${leagueCode}/${slug}.png`;
}
